import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchContracts = ({ accountId }) => get(`/accounts/${accountId}/contracts`);

export const addContract = ({ accountId, ...params }) => post(`/accounts/${accountId}/contracts`, params);

export const updateContract = ({ accountId, contractId, ...params }) =>
  patch(`/accounts/${accountId}/contracts/${contractId}`, params);

export const deleteContract = ({ accountId, contractId }) =>
  httpDelete(`/accounts/${accountId}/contracts/${contractId}`);
